const {
  REACT_APP_API_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_VERSION,
  REACT_APP_WEATHER_ECO_LABEL,
  REACT_APP_WEATHER_ECO_LAT,
  REACT_APP_WEATHER_ECO_LON,
  REACT_APP_WEATHER_ECO_TIMEZONE,
  REACT_APP_WEATHER_OEM_LABEL,
  REACT_APP_WEATHER_OEM_LAT,
  REACT_APP_WEATHER_OEM_LON,
  REACT_APP_WEATHER_OEM_TIMEZONE,
} = process.env

const ecoWeatherConfig = {
  label: REACT_APP_WEATHER_ECO_LABEL || 'Río Cuarto, Córdoba',
  lat: REACT_APP_WEATHER_ECO_LAT,
  lon: REACT_APP_WEATHER_ECO_LON,
  timeZone: REACT_APP_WEATHER_ECO_TIMEZONE,
}

const oemWeatherConfig = {
  label: REACT_APP_WEATHER_OEM_LABEL || 'Villa Mercedes, San Luis',
  lat: REACT_APP_WEATHER_OEM_LAT,
  lon: REACT_APP_WEATHER_OEM_LON,
  timeZone: REACT_APP_WEATHER_OEM_TIMEZONE,
}

const config = {
  API_URL: REACT_APP_API_URL,
  environment: REACT_APP_ENVIRONMENT,
  version: REACT_APP_VERSION,
  weather: {
    eco: ecoWeatherConfig,
    oem: oemWeatherConfig,
  },
}

export default config
